export default __webpack_public_path__ + "static/media/batch-orange.23417c67.svg";